const HASH_FN: string = 'SHA-256';

const generateChecksum = async (input: unknown): Promise<string> => {
    const textEncoder: TextEncoder = new TextEncoder();
    const data: Uint8Array = textEncoder.encode(JSON.stringify(input));
    const hashBuffer: ArrayBuffer = await crypto.subtle.digest(HASH_FN, data);
    const hashArray: number[] = Array.from(new Uint8Array(hashBuffer));

    return hashArray.map((a: number): string => a.toString(16).padStart(2, '0')).join('');
};

export { generateChecksum };
